import {
  RequestDetailsCancelButtonContainer,
  RequestDetailsCancelContainer,
  RequestDetailsCancelParagraph,
  RequestDetailsCancelTextContainer,
  RequestDetailsCancelTitle,
  RequestDetailsPrimaryButton,
  DefaultButtonStyle,
} from './styles/RequestDetailsCancelPopup.styled';

interface RequestDetailsCancelPopupContainerProps {
  cancelRequestHandler: () => void;
  hideCancelPopup: () => void;
}

export const RequestDetailsCancelPopupContainer = ({
  cancelRequestHandler,
  hideCancelPopup,
}: RequestDetailsCancelPopupContainerProps) => {
  return (
    <RequestDetailsCancelContainer role="document">
      <RequestDetailsCancelTextContainer>
        <RequestDetailsCancelTitle>
          Are you sure you want to cancel this request?
        </RequestDetailsCancelTitle>
        <RequestDetailsCancelParagraph>
          All of your data for this request will be cancelled.
        </RequestDetailsCancelParagraph>
      </RequestDetailsCancelTextContainer>
      <RequestDetailsCancelButtonContainer>
        <DefaultButtonStyle appearance={'secondary'} onClick={hideCancelPopup}>
          Go back
        </DefaultButtonStyle>
        <RequestDetailsPrimaryButton
          appearance={'primary'}
          onClick={cancelRequestHandler}
        >
          Cancel request
        </RequestDetailsPrimaryButton>
      </RequestDetailsCancelButtonContainer>
    </RequestDetailsCancelContainer>
  );
};
